module.exports = __webpack_public_path__ + "img/quote-child.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/quote-child.jpg
// module id = 236
// module chunks = 0